<style lang="scss" scoped>
img {
	border-radius: 8px;
}
</style>

<template lang="pug">
    img(v-fallback-icon="true", :src="imagePath", :style="{ width: `${this.size}px` }")
</template>

<script>
import { isEqual } from "lodash";

export default {
	props: {
		icon: {
			type: [String, Object],
			required: true,
			validator: value => {
				// If String
				if (typeof value === "string") return true;

				// If Object
				delete value.__typename;
				return isEqual(Object.keys(value), ["type", "value"]);
			}
		},
		size: {
			type: Number,
			default: 110
		}
	},
	computed: {
		imagePath() {
			if (!this.icon) return null;
			if (typeof this.icon === "string") return this.icon;

			switch (this.icon.type) {
				case "icon":
					return `/static/img/icon-sets/bespoke/${this.icon.value}.png`;
				case "emoji":
					return `https://edu.wonde.com/emoji-assets/128/${this.icon.value}.png`;
				case "custom":
					return this.icon.value;
				default:
					return null;
			}
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/ui/IconImage.vue